module.exports = __webpack_public_path__ + "img/video-thumbnail.d20f2fc5.png";